/** WD-06 responsive media paths — originals stay in public/; derivatives in public/media/. */

export const HERO_VIDEO = {
  hd: '/media/websitehero-720.mp4',
  sd: '/media/websitehero-480.mp4',
  original: '/websitehero.mp4',
};

export const FOUNDER_VIDEO = {
  src: '/media/founder-720.mp4',
  poster: '/media/founder-poster.jpg',
  original: '/8-30-25-data_rook-_one_knox (1080p).mp4',
  /** Set when owner supplies public/captions/founder.vtt */
  captionsSrc: null,
};

/** Original public path -> derivative slug + width sets */
export const IMAGE_DERIVATIVES = {
  '/improve_passing.JPG': {
    slug: 'improve_passing',
    widths: [800, 1280, 1920],
    defaultWidth: 1280,
    modalWidth: 1920,
    sizes: '100vw',
  },
  '/class_looks_at_heatmap_on_big_screen.png': {
    slug: 'class_heatmap',
    widths: [480, 800, 1280],
    defaultWidth: 800,
    modalWidth: 1280,
    sizes: '(max-width: 1024px) 100vw, 448px',
  },
  '/Staff_Smiles.JPG': {
    slug: 'staff_smiles',
    widths: [400, 800, 1280],
    defaultWidth: 800,
    modalWidth: 1280,
    sizes: '(max-width: 1024px) 100vw, 50vw',
  },
  '/kids_at_computer.png': {
    slug: 'kids_at_computer',
    widths: [400, 800, 1280],
    defaultWidth: 800,
    modalWidth: 1280,
    sizes: '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw',
  },
  '/kids_coding.png': {
    slug: 'kids_coding',
    widths: [400, 800, 1280],
    defaultWidth: 800,
    modalWidth: 1280,
    sizes: '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw',
  },
  '/teacher_helps_student_code.png': {
    slug: 'teacher_helps_student',
    widths: [400, 800, 1280],
    defaultWidth: 800,
    modalWidth: 1280,
    sizes: '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw',
  },
  '/problem_solving.png': {
    slug: 'problem_solving',
    widths: [400, 800, 1280],
    defaultWidth: 800,
    modalWidth: 1280,
    sizes: '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw',
  },
  '/back_of_shirt_sponsors.png': {
    slug: 'shirt_sponsors',
    widths: [640, 1280],
    defaultWidth: 1280,
    modalWidth: 1280,
    sizes: '(max-width: 1024px) 100vw, 50vw',
  },
  '/gus_profile.jpg': {
    slug: 'gus_profile',
    widths: [192, 384],
    defaultWidth: 384,
    modalWidth: 384,
    sizes: '192px',
  },
  '/gus_profile.JPG': {
    slug: 'gus_profile',
    widths: [192, 384],
    defaultWidth: 384,
    modalWidth: 384,
    sizes: '192px',
  },
  '/derek_profile.png': {
    slug: 'derek_profile',
    widths: [192, 384],
    defaultWidth: 384,
    modalWidth: 384,
    sizes: '192px',
  },
  '/media/play-800.webp': {
    slug: 'play',
    widths: [400, 800],
    ext: 'webp',
    defaultWidth: 800,
    modalWidth: 800,
    sizes: '(max-width: 767px) calc(100vw - 2.5rem), 33vw',
  },
  '/media/analyze-800.webp': {
    slug: 'analyze',
    widths: [400, 800],
    ext: 'webp',
    defaultWidth: 800,
    modalWidth: 800,
    sizes: '(max-width: 767px) calc(100vw - 2.5rem), 33vw',
  },
  '/media/create-800.webp': {
    slug: 'create',
    widths: [400, 800],
    ext: 'webp',
    defaultWidth: 800,
    modalWidth: 800,
    sizes: '(max-width: 767px) calc(100vw - 2.5rem), 33vw',
  },
};

export const mediaUrl = (slug, width, ext = 'jpg') => `/media/${slug}-${width}.${ext}`;

export const buildSrcSet = (slug, widths, ext = 'jpg') =>
  widths.map((w) => `${mediaUrl(slug, w, ext)} ${w}w`).join(', ');

export const getResponsiveImage = (originalPath) => {
  const config = IMAGE_DERIVATIVES[originalPath];
  if (!config) {
    return { src: originalPath, srcSet: undefined, sizes: undefined, modalSrc: originalPath };
  }
  const { slug, widths, defaultWidth, modalWidth, sizes, ext = 'jpg' } = config;
  return {
    src: mediaUrl(slug, defaultWidth, ext),
    srcSet: buildSrcSet(slug, widths, ext),
    sizes,
    modalSrc: mediaUrl(slug, modalWidth, ext),
  };
};

/** Enrich gallery photo records with responsive fields */
export const withResponsivePhoto = (photo) => {
  const config = IMAGE_DERIVATIVES[photo.src];
  const responsive = getResponsiveImage(photo.src);
  const ext = config?.ext || 'jpg';
  return {
    ...photo,
    ...responsive,
    thumbSrc: mediaUrl(config?.slug || '', config?.widths[0] || 400, ext),
  };
};
